<template>
    <ContentOrLoading>
        <div class="card">
            <div class="card-header">
                <div class="text-center text-lg-left">
                    <div class="d-md-flex justify-content-md-between">
                        <h3 class="card-title my-3">
                            Precios para las regiones
                        </h3>
                        <div>
                            <Button @click="showModal('crearEntrada')" id="createEntrada">Crear precio</Button>
                        </div>
                    </div>
                    <CreateModal :region="true" :sesion="sesion" @close="closeModal" />
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <ContentOrLoading>
                            <div v-if="! loadingEntradas && entradas && entradas.length > 0">
                                <div v-for="(entrada, index) in entradas" class="row mb-4" :key="index">
                                    <div class="col-6 col-md-10">
                                        <div class="row">
                                            <div class="col-12 col-md-3">
                                                <strong>{{ entrada.description }}</strong>
                                            </div>
                                            <div class="col-12 col-md-3">
                                                <i class="text-green fas fa-laptop"></i>
                                                {{ entrada.price_management_online_interno ? parseFloat(entrada.price) : (parseFloat(entrada.price) + parseFloat(entrada.price_management_online)) | formatear_precio }}
                                            </div>
                                            <div class="col-12 col-md-3">
                                                <i class="text-green fas fa-store"></i>
                                                {{ entrada.price_management_taquilla_interno ? parseFloat(entrada.price) : (parseFloat(entrada.price) + parseFloat(entrada.price_management_taquilla)) | formatear_precio }}
                                            </div>
                                            <div class="col-12 col-md-3">
                                                <label>
                                                    {{ entrada.dia_abonado ? 'Día de abonado' : entrada.acompanante_abonado ? 'Acompañante de abonado' : entrada.amigo_abonado ? 'Amigo de abonado' : 'Normal' }}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-2">
                                        <OpcionesDropdownComponent 
                                            v-bind:options="[
                                                {
                                                    type: 'action',
                                                    action: () => showModal('editarEntrada-' + entrada.id),
                                                    label: 'Editar',
                                                },
                                                {
                                                    type: 'action',
                                                    action: () => showModal('deleteEntrada-' + entrada.id),
                                                    label: 'Borrar',
                                                },
                                            ]" 
                                        />
                                    </div>
                                    <EditModal 
                                        :sesion="sesion" 
                                        :evento_id="$route.params.evento_id" 
                                        :entrada="entrada"
                                        :region="true"
                                        @close="closeModal" 
                                    />
                                    <BorrarModal
                                        id="borrarModal"
                                        :name="'deleteEntrada-' + entrada.id"
                                        title="¿Está seguro de que desea eliminar este precio?"
                                        confirmButton="Borrar precio" 
                                        @close="closeModal"
                                        @confirm="deleteEntrada(entrada.id)" 
                                    />
                                </div>
                            </div>
                            <div v-else-if="entradas && entradas.length === 0">
                                <div class="col-12">
                                    <strong>Este recinto anexo no tiene precios</strong>
                                </div>
                            </div>
                        </ContentOrLoading>
                    </div>
                </div>
            </div>
        </div>
        <div class="card" v-if="! regionSeleccionada && regiones">
            <div class="card-header">
                <div class="text-center text-lg-left">
                    <div class="d-md-flex justify-content-md-between">
                        <h3 class="card-title my-3">
                            Seleccione la región
                        </h3>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <ContentOrLoading>
                            <SvgComponent 
                                v-if="regiones && regiones.length > 0 "
                                :zonas="regiones" 
                                :place="place" 
                                :sesion_id="$route.params.sesion_id"
                                :config_precios="true"
                                @clickZona="getPlazas"
                            />
                        </ContentOrLoading>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="regionSeleccionada">
            <div v-if="!loading" class="card card-primary card-outline card-outline-tabs">
                <div class="card-header p-0 border-bottom-0">
                    <ul class="nav nav-tabs" id="custom-tabs-five-tab" role="tablist">
                        <li class="nav-item" v-if="regionSeleccionada.tipo_svg != 1">
                            <a href="#" :class="tab == 'porPlano' ? 'nav-link active' : 'nav-link'"
                                @click.prevent="tab = 'porPlano'">
                                Configurar precios desde el plano
                            </a>
                        </li>
                        <li class="nav-item">
                            <a href="#" :class="tab == 'porPlazas' ? 'nav-link active' : 'nav-link'"
                                @click.prevent="tab = 'porPlazas'">
                                Configurar por plaza/butaca
                            </a>
                        </li>
                        <li class="nav-item">
                            <a href="#" :class="tab == 'porSectores' ? 'nav-link active' : 'nav-link'"
                                @click.prevent="tab = 'porSectores'">
                                Configurar por sectores
                            </a>
                        </li>
                        <li class="nav-item">
                            <a href="#" :class="tab == 'general' ? 'nav-link active' : 'nav-link'"
                                @click.prevent="tab = 'general'">
                                Configuración general
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="card-body">
                    <div class="tab-content">
                        <div class="tab-pane fade active show">
                            <transition name="fade" mode="out-in">
                                <div key="1" class="overlay-wrapper" v-if="tab == 'porPlano' && regionSeleccionada.tipo_svg != 1">
                                    <PorPlano
                                        :place="place"
                                        :region="regionSeleccionada"
                                        :sectores="sectores"
                                        :entradas="entradas"
                                        :plazas="plazas"
                                        @recargar="getPlazas"
                                        @volver="regionSeleccionada = null"
                                    />
                                </div>
                                <div key="2" class="overlay-wrapper" v-if="tab == 'porPlazas'">
                                    <PorPlazas
                                        :region="regionSeleccionada"
                                        :entradas="entradas"
                                        :plazas="plazas"
                                        @recargar="getPlazas"
                                        @volver="regionSeleccionada = null"
                                    />
                                </div>
                                <div key="3" class="overlay-wrapper" v-if="tab == 'general'">
                                    <General 
                                        :region_id="regionSeleccionada.id"
                                        :recinto_id="place.id"
                                        :entradas="entradas"
                                        @recargar="getPlazas"
                                        @volver="regionSeleccionada = null"
                                    />
                                </div>
                                <div key="4" class="overlay-wrapper" v-if="tab == 'porSectores'">
                                    <PorSectores 
                                        :region_id="regionSeleccionada.id"
                                        :entradas="entradas"
                                        :recinto_id="place.id"
                                        @recargar="getPlazas"
                                        @volver="regionSeleccionada = null"
                                    />
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
import OpcionesDropdownComponent from '@/components/backend/components/OpcionesDropdownComponent'
import PorPlazas from '@/components/backend/eventos/sesiones/plazas/PorPlazas';
import General from '@/components/backend/eventos/sesiones/plazas/General';
import CreateModal from './modals/CreateEntradaModal';
import EditModal from './modals/EditEntradaModal';
import BorrarModal from '@/components/backend/components/BorrarModalComponent';
import PorSectores from '@/components/backend/eventos/sesiones/plazas/PorSectores.vue';
import PorPlano from './PorPlano.vue';
import SvgComponent from '@/components/svg/SvgComponent';

export default {
    props: ['place'],
    data() {
        return {
            tab: 'porPlano',
            entradas: null,
            plazas: null,
            sectores: null,
            sesion: null,
            loading: false,
            loadingEntradas: false,
            regionSeleccionada: false,
            regiones: null
        }
    },
    created() {
        this.getSesion()
        this.getEntradas()
        this.getRegiones()
    },
    methods: {
        getSesion() {
            this.loading = true

            const params = {
                filters: {},
                evento_id: this.$route.params.evento_id,
                sesion_id: this.$route.params.sesion_id,
            }

            this.$store
                .dispatch(
                    this.config.getVuexAlias('back.events.sesiones.show'),
                    params
                )
                .then(res => {
                    this.sesion = res.data.data
                })
                .finally(() => (this.loading = false))
        },
        getRegiones() {
            this.loading = true;
            
            let params = {
                filters: {
                    con_plazas: true
                },
                evento_id: this.$route.params.evento_id,
                sesion_id: this.$route.params.sesion_id,
                recinto_id: this.place.id
            }

            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.settings.regiones-anexas'), params)
                .then(res => {
                    this.regiones = res.data.data;
                    if(this.regiones.length === 1){
                        this.regionSeleccionada = this.regiones[0];
                        this.getPlazas(this.regionSeleccionada);
                    }
                    this.loading = false;
                }).catch(error => {
                    console.log(error);
                    this.loading = false;
                })
        },
        getEntradas() {
            this.loadingEntradas = true;

            let params = {
                filters: {},
                evento_id: this.$route.params.evento_id,
                sesion_id: this.$route.params.sesion_id,
                recinto_id: this.place.id
            }

            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.settings.regiones-anexas.precios'), params)
                .then(res => {
                    this.entradas = res.data.data;
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.loadingEntradas = false;
                });
        },
        getPlazas(region = null, tipo) {
            this.regionSeleccionada = region ?? this.regionSeleccionada;
            this.loading = true;

            if (this.regionSeleccionada.tipo_svg == 1) {
                this.tab = 'porPlazas';
            } else if (this.regionSeleccionada.tipo_svg == 2) {
                this.tab = 'porPlano';
            }

            let params = {
                filters: {},
                evento_id: this.$route.params.evento_id,
                sesion_id: this.$route.params.sesion_id,
                recinto_id: this.place.id,
                region_id: this.regionSeleccionada.id
            }

            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.settings.zona.butacas'), params)
                .then(res => {
                    this.plazas = res.data.data;
                    if (tipo) {
                        this.tab = tipo;
                    }
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.loading = false;
                });
        },
        deleteEntrada(entradaId) {
            let params = {
                filters: {},
                evento_id: this.$route.params.evento_id,
                sesion_id: this.$route.params.sesion_id,
                entrada_plaza_id: entradaId
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.plazas.tickets.borrar'), params)
                .then(res => {
                    if (res.data.error) {
                        this.$toast.error(res.data.message)
                    } else {
                        this.closeModal(`deleteEntrada-${entradaId}`, true);
                        this.$toast.success(res.data.message);
                        this.getEntradas();
                    }
                }).catch(error => {
                    console.log(error);
                });
        },
        showModal(modal) {
            this.$modal.show(modal)
        },
        closeModal(modal, creado) {
            if (creado) {
                this.getEntradas();
            }
            this.$modal.hide(modal)
        }
    },
    components: { OpcionesDropdownComponent, PorPlazas, General, CreateModal, EditModal, BorrarModal, PorSectores, PorPlano, SvgComponent }
}
</script>